import React, { useEffect, useReducer, useState } from "react";
import { GACntxt } from "../../AllianceApp";


const formReducer = (state: any, event: any) => {
    return {
        ...state,
        [event.name]: event.value
    }
}



const ProfileForm = () => {

    const [userTGAid, setUserTGAID] = useState(null);
    const [formData, setFormData] = useReducer(formReducer, {});
    const [submitting, setSubmitting] = useState(false);
    const [dupeUser, setDupeUser] = useState(false);
    const [broken, setBroken] = useState(false);
    const [success, setSuccess] = useState(false);


    const userContext = React.useContext(GACntxt);

    

    const getTGAid = React.useCallback((dat: {tga_id: any}) => {
        return (dat ? dat.tga_id : null);
    }, []);





    //Effect to set up form on Mount
    useEffect(() => {

        const getUserData = async (userID: number) => {
            try {
                const accessToken = userContext.userAccessToken;

                const userDataResponse = await fetch(process.env.REACT_APP_REFLEBULA + "/a1/tga/user/" + userID + "", { headers: { Authorization: `Bearer ${accessToken}`, }, });

                const { user_name, email, first_name, last_name } = await userDataResponse.json();

                setFormData({ name: "user_name", value: user_name, });
                setFormData({ name: "email", value: email, });
                setFormData({ name: "first_name", value: first_name, });
                setFormData({ name: "last_name", value: last_name, });

                //console.log("user_name = " + user_name);
                //console.log(formData);
            }
            catch (e: any) {
                console.log("editprofile=>getUserData: " + e.message);

                setFormData({ name: "user_name", value: "", });
                setFormData({ name: "email", value: "", });
                setFormData({ name: "first_name", value: "", });
                setFormData({ name: "last_name", value: "", });
            }
        };
        if(userContext.userMetadata !== undefined)
        {
            const temp_id = getTGAid(userContext.userMetadata);
            setUserTGAID(temp_id);
            if(temp_id !== null)
            {
                getUserData(temp_id);
            }
            else
            {
                setFormData({ name: "user_name", value: "", });
                setFormData({ name: "email", value: "", });
                setFormData({ name: "first_name", value: "", });
                setFormData({ name: "last_name", value: "", });
            }
        }

        
    }, [userContext]);




    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({ name: event.target.name, value: event.target.value, });
    }





    const saveFormData = async () => {
        const accessToken = userContext.userAccessToken;

        const response = await fetch(process.env.REACT_APP_REFLEBULA + "/a1/tga/user/" + userTGAid + "", { headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' }, method: 'POST', body: JSON.stringify(formData) });

        if (response.status === 200) {
            setSuccess(true);
        }
        else if (response.status === 400) {
            setDupeUser(true);
            setBroken(true);
        }
        else {
            setBroken(true);
            console.log(`Profile edit save attempt failed: ${response.status} ${response.statusText}`);
            //console.log("r: " + resp.keys());
            throw new Error(`Profile edit save attempt failed: ${response.status} ${response.statusText}`);
        }
    }





    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault(); // Prevent default submission
        setDupeUser(false);
        setBroken(false);
        setSuccess(false);
        setSubmitting(true);

        try {
            await saveFormData();
        }
        catch (e: any) {
            console.log(`Profile edit save failed! ${e.message}`);
        }

        setSubmitting(false);
    }




    if (userContext.userTGAName !=="") {

        return (
            <React.Fragment>
                <hr />

                <div>
                    {submitting &&
                        <p>Attempting to save data to the server...</p>
                    }
                    {broken &&
                        <p>There was a problem saving data to the server.</p>
                    }
                    {success &&
                        <p>Successfully saved data to the server.</p>
                    }
                </div>

                <div>
                    <form onSubmit={handleSubmit}>
                        <fieldset>
                            <label>*User Name:
                                <input style={{ width: "250px", }} type="text" name="user_name" value={formData.user_name || ""} onChange={handleChange} required={true} /> {dupeUser && <span>this user name is currently taken</span>}
                            </label>

                            <br /><br />

                            <label>e-mail:
                                <input style={{ width: "250px", }} type="text" name="email" value={formData.email || ""} onChange={handleChange} disabled /> currently uneditable
                            </label>

                            <br /><br />

                            <label>First:
                                <input type="text" name="first_name" value={formData.first_name || ""} onChange={handleChange} />
                            </label>

                            <br /><br />

                            <label>Last:
                                <input type="text" name="last_name" value={formData.last_name || ""} onChange={handleChange} />
                            </label>
                        </fieldset>

                        <br /><br />

                        <div>
                            <input type="submit" disabled={submitting} />
                            &nbsp; by clicking this "Submit" button, you
                            acknowledge and agree to the Tabletop Gamers
                            Alliance (AKA TGA AKA Gamers Alliance LLC)
                            Online Terms of Service listed below:
                            <ol>
                                <li>
                                    TGA's record of your e-mail address
                                    will:
                                    <p>
                                        a) Be utilized to differentiate
                                        your user profile data from other
                                        users' profile data.
                                    </p>
                                    <p>
                                        b) Be used by TGA to directly
                                        contact you for the purposes that
                                        you have initiated with TGA such as
                                        TGA account issues, TGA event
                                        registrations, and correspondence
                                        that you have directly opted-in to.
                                    </p>
                                    <p>
                                        c) Only be subject to communication
                                        distribution lists or groups that
                                        you directly opt-in to.
                                    </p>
                                    <p>
                                        d) Not be sold nor distributed to
                                        any parties external to TGA.
                                    </p>
                                </li>
                                <li>
                                    Public-facing fields of your user
                                    profile data are socially decent and
                                    not offensive to other TGA Online
                                    users. Any user profile data that TGA
                                    deems in-violation of this clause, will
                                    be subject to sanitization by TGA.  Any
                                    user that repeatedly violates this
                                    clause will be subject to revocation of
                                    their TGA Online account.
                                </li>
                            </ol>
                        </div>
                    </form>
                </div>
            </React.Fragment>
        );
    }
    else {
        return (
            <React.Fragment>
                <div>Unable to retrieve user data.</div>
            </React.Fragment>
        );
    }
};
export default ProfileForm;